import { render, staticRenderFns } from "./EmployeeTabReminders.vue?vue&type=template&id=184d8792&"
import script from "./EmployeeTabReminders.vue?vue&type=script&lang=js&"
export * from "./EmployeeTabReminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports